export default "__VITE_PUBLIC_ASSET__490e6056__"